
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Venue } from '@/interfaces/models/Venue';

@Component
export default class CopyBtn extends Vue {
  @Prop({ type: Array, required: true }) public venues!: Venue[];
}
